import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import tinycolor from 'tinycolor2';
import { animated } from '@react-spring/web';

import { useScreenSize, useScreenRenderContext, useViewer } from '@micromag/core/contexts';

import Container from '@micromag/element-container';

import Image from '../partials/Image';
import Html from '../partials/Html';

import styles from '../../../styles/screens/history.module.scss';

const propTypes = {
    image: PropTypes.shape({
        id: PropTypes.string,
    }),
    year: PropTypes.string,
    description: PropTypes.string,
    alt: PropTypes.string,
    yearColor: PropTypes.string,
    backgroundColorGradient: PropTypes.shape({
        primary: PropTypes.string,
        secondary: PropTypes.string,
    }),
    // current: PropTypes.bool,
    // active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    image: null,
    year: null,
    description: null,
    alt: null,
    yearColor: null,
    backgroundColorGradient: null,
    // current: true,
    // active: true,
    className: null,
};

const HistoryScreen = ({
    image,
    year,
    description,
    alt,
    yearColor,
    backgroundColorGradient,
    // current,
    // active,
    className,
}) => {
    const { primary = null, secondary = null } = backgroundColorGradient || {};

    const descriptionColor = useMemo(
        () => (secondary !== null && tinycolor(secondary).isDark() ? '#FFF' : '#000'),
        [secondary],
    );

    const { width, height } = useScreenSize(); // menuOverScreen

    // const { isPlaceholder, isPreview, isView, isEdit, isStatic, isCapture } =
    //     useScreenRenderContext();
    // const { menuSize } = useViewer();

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Container width={width} height={height}>
                {image !== null ? (
                    <animated.div className={styles.imageContainer}>
                        <Image
                            className={styles.image}
                            media={image}
                            alt={alt}
                            fit="contain"
                            size="medium"
                        />
                    </animated.div>
                ) : null}
                <div
                    className={styles.inner}
                    style={{
                        backgroundImage: `linear-gradient(to bottom, ${primary} 0%, ${secondary} 100%)`,
                    }}
                >
                    <animated.div className={styles.content}>
                        <div className={styles.elements}>
                            <div className={styles.top}>
                                {year !== null ? (
                                    <div className={styles.year} style={{ color: yearColor }}>
                                        {year}
                                    </div>
                                ) : null}
                            </div>
                            <div style={{ color: descriptionColor }}>
                                <Html className={styles.description} body={description} />
                            </div>
                        </div>
                    </animated.div>
                </div>
            </Container>
        </div>
    );
};

HistoryScreen.propTypes = propTypes;
HistoryScreen.defaultProps = defaultProps;

export default React.memo(HistoryScreen);
